import { render, staticRenderFns } from "./IndexPageEmptyState.vue?vue&type=template&id=7da3f510&scoped=true&"
import script from "./IndexPageEmptyState.vue?vue&type=script&lang=ts&"
export * from "./IndexPageEmptyState.vue?vue&type=script&lang=ts&"
import style0 from "./IndexPageEmptyState.vue?vue&type=style&index=0&id=7da3f510&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da3f510",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFlex,VIcon,VLayout})
